import script from "./ProductListing.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProductListing.vue?vue&type=script&setup=true&lang=ts"

import "./ProductListing.vue?vue&type=style&index=0&id=32934128&lang=sass&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-32934128"]])

export default __exports__